import React, {Component}   from 'react';
import PropTypes            from 'prop-types';

class FieldWarning extends Component {
    render() {
        let warningList = this.props.warnings;
        return (
            <div>
                {typeof this.props.warnings[0] !== 'undefined' ? (
                    <div className="error-container error-right">
                        <div className={'content warning'}>
                            <div className="arrow" />
                            <div className="error-content">
                                <ul className="list-unstyled">
                                    {warningList.map(function(text, index) {
                                        return (
                                            <li key={index}>{text}</li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

FieldWarning.propTypes = {
    warnings: PropTypes.array,
    type:   PropTypes.string,
};

FieldWarning.defaultProps = {
    warnings: [],
    type:   'error',
};

export default FieldWarning;


// WEBPACK FOOTER //
// ./src/components/Fragments/FieldWarning.js